<template>
  <div class="invoice-settings">

    <vs-row>
      <vs-col vs-justify="center" vs-align="center" vs-w="12">
        <div class="table-title">
          <p>{{$t('dash.settings.invoices.title')}}</p>
        </div>

        <vs-alert v-if="noInvoice" active="true" color="#842993">
          {{$t('dash.settings.invoices.noinvoices')}}
        </vs-alert>

        <component-table
          v-if="!noInvoice"
          :gridData="gridData"
          :columns="gridColumns"
          :name="'invoice'"
          v-on:action-clicked="download">
        </component-table>

      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import moment from 'moment'

import componentTable from './../Table.vue'
import Invoices from '../../mixins/Invoices'


export default {
  name: 'component-invoice',

  mixins: [Invoices],

  components: {
    componentTable
  },

  data() {
    return {
      noInvoice: false,
      gridColumns: ['date', 'amount', 'plan', 'actions'],
      gridData: []
    }
  },

  beforeMount(){
    localStorage.setItem('section', 'settings')
    this.$ga.page(this.$router)
    this.listInvoices().then(res => {
      if(!res.data || !res.data.invoices || !res.data.invoices.length) 
        return this.noInvoice = true

      this.gridData = res.data.invoices.map((invoice) => {
        moment.locale(this.$i18n.locale)
        return {
          //date : moment.unix(invoice.date).format('MMMM Do YYYY'),
          date : moment.unix(invoice.date).local(this.$i18n.locale).format('LLL'),
          //amount : (invoice.amount_paid/100).toFixed(2) + '€',
          amount : (invoice.amount_due/100).toFixed(2) + '€',
          plan : invoice.lines.data[0].plan
            ? invoice.lines.data[0].plan.nickname
            : '',
          pdf : invoice.invoice_pdf
        }
      })
    })
  },

  methods: {
    /**
     * Download invoice
     * @param {Number} index - Invoice index to download
     */
    download(index) {
      const invoice = this.gridData[index]
      const link = document.createElement("a");
      link.download = 'Invoice';
      link.href = invoice.pdf;
      link.click();
    }
  }
}    
</script>
